/** @jsxImportSource react */
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenant } from '../../store/slices/tenantSlice'
import { useMyTenants } from '../../hooks/useCrmQueries'
import Loading from './Loading'

/**
 * Requires a selected tenant that is still ACTIVE for this user, and keeps the stored
 * role in sync with the server (an admin may have been demoted since the last visit).
 */
const TenantRoute = ({ children }) => {
  const dispatch = useDispatch()
  const current = useSelector((state) => state.tenant.current)
  const { data: tenants, isLoading } = useMyTenants()

  const match = tenants?.find((t) => t.tenantId === current?.tenantId)
  const valid = match && match.status === 'ACTIVE'

  useEffect(() => {
    if (match && (match.role !== current.role || match.name !== current.name || match.status !== current.status)) {
      dispatch(selectTenant(match))
    }
  }, [match, current, dispatch])

  if (!current) return <Navigate to="/select-tenant" replace />
  if (isLoading) return <Loading fullScreen />
  if (tenants && !valid) return <Navigate to="/select-tenant" replace />
  return children
}

export default TenantRoute
